import * as React from 'react'
import { Breadcrumbs } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { STEPS } from './types'

interface Props {
  step: STEPS
  isAddingCustomer?: boolean
}

const getActiveBreadcrumb = (
  step: STEPS,
  breadcrumbs: string[],
  isAddingCustomer: boolean
): string => {
  if (step === STEPS.REVIEW_DETAILS && !isAddingCustomer) {
    return breadcrumbs[step - 2]
  }
  return breadcrumbs[step - 1]
}

export const StepBreadcrumbs: React.FC<Props> = ({
  step,
  isAddingCustomer = false,
}) => {
  const t = useT()
  const breadcrumbsContext = 'Breadcrumb text in quotes modal'

  const breadcrumbs = React.useMemo(
    () =>
      isAddingCustomer
        ? [
            t('Customer', { _context: breadcrumbsContext }),
            t('Add', { _context: breadcrumbsContext }),
            t('Details', { _context: breadcrumbsContext }),
          ]
        : [
            t('Customer', { _context: breadcrumbsContext }),
            t('Details', { _context: breadcrumbsContext }),
          ],
    [t, isAddingCustomer]
  )

  const activeBreadcrumb = getActiveBreadcrumb(
    step,
    breadcrumbs,
    isAddingCustomer
  )

  return (
    <Breadcrumbs
      breadcrumbs={breadcrumbs}
      activeBreadcrumb={activeBreadcrumb}
    />
  )
}
